import { useEffect, useRef, useState } from 'react';

const FLASH_MS = 400;

const usePagingFlash = (page: number, rowsPerPage: number) => {
  const [flashing, setFlashing] = useState(false);
  const previous = useRef({ page, rowsPerPage });

  useEffect(() => {
    if (previous.current.page === page && previous.current.rowsPerPage === rowsPerPage) return undefined;
    previous.current = { page, rowsPerPage };
    setFlashing(true);
    const timer = setTimeout(() => setFlashing(false), FLASH_MS);
    return () => clearTimeout(timer);
  }, [page, rowsPerPage]);

  return flashing;
};

export default usePagingFlash;
